<div class="ui-notification-menu">
  <ul class="ui-notification-menu__list">
    @for (item of visibleItems(); track item.id) {
      <li class="ui-notification-menu__item" (click)="onItem(item)">
        <div class="ui-notification-menu__head">
          <p class="ui-notification-menu__title">
            <span
              class="ui-notification-menu__status-dot"
              [class.ui-notification-menu__status-dot--read]="item.read"
              aria-hidden="true"
            ></span>
            {{ item.title }}
          </p>
          <ui-tag
            [label]="item.read ? 'Leída' : 'No leída'"
            [color]="item.read ? 'neutral' : 'warning'"
          />
        </div>
        <div class="ui-notification-menu__body">
          <p class="ui-notification-menu__date">{{ item.datetime }}</p>
          @if (item.project) {
            <p class="ui-notification-menu__context">{{ item.project }}</p>
          }
          @if (showsProperty(item)) {
            <p class="ui-notification-menu__meta">
              <span>Modelo: {{ item.model }}</span>
              <span>Unidad: {{ item.unit }}</span>
            </p>
          }
          @if (item.context) {
            <p class="ui-notification-menu__context">{{ item.context }}</p>
          }
          <p class="ui-notification-menu__message">{{ item.message }}</p>
        </div>
      </li>
    }
  </ul>
  <div class="ui-notification-menu__footer">
    <ui-button variant="ghost" size="sm" [block]="true" (pressed)="onViewAll()">
      {{ viewAllLabel() }}
    </ui-button>
  </div>
</div>
